import { render } from "./freeShareSunset.vue?vue&type=template&id=0f0925f3&scoped=true"
import script from "./freeShareSunset.vue?vue&type=script&lang=ts"
export * from "./freeShareSunset.vue?vue&type=script&lang=ts"

import "./freeShareSunset.vue?vue&type=style&index=0&id=0f0925f3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0f0925f3"

export default script